import { createSelector } from 'reselect';

const selectRepoList = state => state.repository.data;
const selectRepoFilter = state => state.repository.filter;
const selectRepoCurrentSelectedIds = state =>
  state.repository.currentSelectedIds;
const selectRepoQ = state => state.repository.q;
const selectCurrentFolderId = state => state.repository.currentFolder;
const selectTargetQ = state => state.repository.targetQ;
const selectCurrentTargetFolderId = state =>
  state.repository.currentTargetFolder;

function findItemNestedChildren(arr, id, selectedIds) {
  if (!id) {
    return arr.map(child => {
      return {
        ...child,
        selected: selectedIds && selectedIds.includes(child.id),
      };
    });
  }

  if (typeof arr !== 'object') {
    return arr;
  }

  return arr.reduce((acc, item) => {
    if (acc) {
      return acc;
    }
    if (item.id.toString() === id.toString()) {
      return item.children
        ? item.children.map(child => {
            return {
              ...child,
              selected: selectedIds && selectedIds.includes(child.id),
            };
          })
        : [];
    }
    if (item.children) {
      return findItemNestedChildren(item.children, id, selectedIds);
    }

    return null;
  }, null);
}

function compareByType(a, b) {
  if (a.type > b.type) {
    return -1;
  }
  if (a.type < b.type) {
    return 1;
  }
  return 0;
}

export const getCurrentTreeView = createSelector(
  [
    selectRepoList,
    selectRepoFilter,
    selectCurrentFolderId,
    selectRepoCurrentSelectedIds,
    selectRepoQ,
  ],
  (
    repoList,
    selectedRepoFilter,
    currentFolderId,
    selectedIds,
    currentRepoQ
  ) => {
    const data = findItemNestedChildren(
      repoList[!currentRepoQ ? selectedRepoFilter : 'search'],
      currentFolderId,
      selectedIds
    );

    return data.sort(compareByType);
  }
);

export const getCurrentTargetTreeView = createSelector(
  [selectRepoList, selectCurrentTargetFolderId, selectTargetQ],
  (repoList, currentSelectedFolder, currentTargetQ) => {
    const data = findItemNestedChildren(
      repoList[!currentTargetQ ? 'my' : 'search'],
      currentSelectedFolder
    );

    return data.sort(compareByType);
  }
);

export const areAllItemsSelected = createSelector(
  [getCurrentTreeView, selectRepoCurrentSelectedIds],
  (currentTreeView, currentSelectedIds) => {
    if (currentSelectedIds.length === 0) {
      return false;
    }

    if (currentTreeView.length === currentSelectedIds.length) {
      return true;
    }

    return 'semi-checked';
  }
);

export const getSelectedItemsCount = createSelector(
  [selectRepoCurrentSelectedIds],
  currentSelectedIds => currentSelectedIds.length
);
